import InputQuantityGroup from './input-quantity-group-view'

export default InputQuantityGroup
